const DownloadLanding = () => import('./DownloadLanding.vue')

export default [
    {
        path: '/download-landing/:taskReference',
        name: 'mediaDownloadLanding',
        component: DownloadLanding,
        meta: {
            title: 'Download',
            label: 'Download',
            allowsUnAuth: true,
        },
    },
]
